export const layout = {
  navbarBase: "55px",
  navbarLg: "120px",
  footerBase: "175px",
  footerLg: "40px",
}